import React, { Component } from "react";
import {
    Button, Collapse,
} from "reactstrap";
import moment from "moment";
import { connect } from "react-redux";
import style from "./MediclaimDetails.module.css";
import { fetchMediclaimDetailsListing, submitClaim } from "../../../../redux";
import ttmLoader from "../../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../../services/RolePermissionService";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import history from "../../../../utils/history";
import { formatNumberToCurrency } from "../../../../utils/CommonUtil";


function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}

export class MediclaimDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice_id: "",
            isDrugRecordOpen: false,
            isScreenLoaded: false,
            reasonType: "",
            submitClaimLoader: false,
            isDeleteModalOpen: false
        };
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        document.title = 'Claim Details - TechToMedix';
        if (this.props.match && this.props.match.params && this.props.match.params.id) {
            await this.props.fetchMediclaimDetailsListing(this.props.match.params.id);
            if (this.props.mediclaimDetailsData &&
                this.props.mediclaimDetailsData.mediclaimDetails &&
                this.props.mediclaimDetailsData.mediclaimDetails.invoice_id) {
                this.setState({
                    invoice_id: this.props.mediclaimDetailsData.mediclaimDetails.invoice_id
                })
            }
        }
        setTimeout(() => {
            this.setState({
                isScreenLoaded: true,
            });
        }, 500);
    }

    checkData = (data) => {
        if (!data) {
            return "Not Available";
        }
        return data;
    }

    checkValidPrice = (data) => {
        if (data || data === 0) {
            return data;
        } else {
            return "Not Available";
        }
    }

    openDrugRecord = () => {
        this.setState({
            isDrugRecordOpen: !this.state.isDrugRecordOpen
        })
    }

    checkDrugRecord = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div className="col-md-12 mt-2">
                {(response && response.map((item, index) => (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Item No. </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_item_no)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Security Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_scecurity_indicator)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>DUR Add Info. Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.dur_add_infor_indicator)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Drug Conflict Code </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.drug_conflict_code)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Previous Date of Fill </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.previous_date_of_fill)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Quantity (Previous Fill) </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.quantity_of_previous_prefill)}
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Other Prescriber Indicator </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.other_Prescriber_Indicator)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 1</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments1)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 2</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments2)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Comments 3</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.comments3)}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Database Indicator</label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.database_indicator)}
                                    </div>
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Other Pharmacy </label> :{" "}
                                    </div>

                                    <div className="col-md-6">
                                        {item && this.checkData(item.otherPharmacy)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                ))
                )}
            </div>
        );
    }

    checkResposneData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.response_code + " " + item.response_description}
                    </p>
                ))
                )}
            </div>
        );
    }

    // toggle a modal
    toggle = (val) => {
        this.setState((prevState) => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            reasonType: "",
        }));
    }

    checkFailureResponseData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);
        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.message}
                    </p>
                ))
                )}
            </div>
        );
    }

    checkGeneralCommentsData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.comment}
                    </p>
                ))
                )}
            </div>
        );

    }

    reverseClaim = async () => {

        this.setState({
            submitClaimLoader: true
        })
        const payload = {
            reverseClaim: true,
            invoice_id: this.state.invoice_id
        }
        await this.props.submitClaim(payload);

        if (!this.props.submitClaimData.loading) {
            if (!this.props.submitClaimData.errorMessage) {
                this.setState({
                    successMessage: this.props.submitClaimData.successMessage,
                    submitClaimLoader: false,
                    errorMessage: ""
                })

                setTimeout(() => {
                    this.setState({
                        successMessage: "",
                    })
                    window.location.reload();
                    // this.props.history.push({
                    //     pathname: "/app/invoicelist"
                    // });
                }, 2000);
            } else {
                this.setState({
                    errorMessage: this.props.submitClaimData.errorMessage,
                    successMessage: "",
                    submitClaimLoader: false
                })

                setTimeout(() => {
                    this.setState({
                        errorMessage: ""
                    })
                }, 2000);

            }
        }

    }
    resubmitClaim = async () => {

        this.setState({
            submitClaimLoader: true
        })
        // const payload = {
        //     reverseClaim: true,
        //     invoice_id: this.state.invoice_id
        // }
        // await this.props.submitClaim(payload);
        console.log('this.state.reasonType',this.state.reasonType)

        
        if (!this.props.submitClaimData.loading) {
            if (!this.props.submitClaimData.errorMessage) {
                this.setState({
                    successMessage: this.props.submitClaimData.successMessage,
                    submitClaimLoader: false,
                    errorMessage: ""
                })

                 this.props.history.push({
                    pathname: "/app/createinvoice/" + this.state.invoice_id,
                    state: {
                        resubmission_code: this.state.reasonType
                    }
                  });
            } else {
                this.setState({
                    errorMessage: this.props.submitClaimData.errorMessage,
                    successMessage: "",
                    submitClaimLoader: false
                })

                setTimeout(() => {
                    this.setState({
                        errorMessage: ""
                    })
                }, 2000);

            }
        }
        // this.props.history.push({
        //     pathname: "/app/createinvoice/" + this.state.invoice_id,
        //     state: {
        //         resubmission_code: this.state.reasonType
        //     }
        // });
    }
    balancePay = () => {

        const data = this.props.mediclaimDetailsData.mediclaimDetails;

        this.props.history.push({
            pathname: "/app/receivepayment",
            state: {
                patient_id: data && data.patient_id ? data.patient_id : "",
                practitioner_id: data && data.practitioner_id ? data.practitioner_id : "",
                isAppointmentPay: true,
                mediswitchTransactionId: this.props.match.params.id,
                //appointment_id: data &&  data.appoinment_id ? data.appoinment_id : "",
                invoice_id: this.state.invoice_id,
                amount: data && data.balance ? Number(data.balance) : 0
            },
        });
    }

    makePayment = () => {

        const data = this.props.mediclaimDetailsData.mediclaimDetails;

        this.props.history.push({
            pathname: "/app/sendpayment",
            state: {
                patient_id: data && data.patient_id ? data.patient_id : "",
                practitioner_id: data && data.practitioner_id ? data.practitioner_id : "",
                isAppointmentPay: true,
                mediswitchTransactionId: this.props.match.params.id,
                //appointment_id: data &&  data.appoinment_id ? data.appoinment_id : "",
                invoice_id: this.state.invoice_id,
                amount: data && data.balance ? -Number(data.balance) : 0
            },
        });
    }

    captureSchemePayment = () => {

        const data = this.props.mediclaimDetailsData.mediclaimDetails;

        this.props.history.push({
            pathname: "/app/receivepayment",
            state: {
                patient_id: data && data.patient_id ? data.patient_id : "",
                practitioner_id: data && data.practitioner_id ? data.practitioner_id : "",
                isAppointmentPay: true,
                mediswitchTransactionId: this.props.match.params.id,
                //appointment_id: data &&  data.appoinment_id ? data.appoinment_id : "",
                invoice_id: this.state.invoice_id,
                amount: data && data.scheme_authorized_amount ? Number(data.scheme_authorized_amount) : 0
            },
        });
    }

    handleReasonChange = (event) => {
        const val = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: val,
        });
    }

    claimResponse = (invoice_id) => {
        this.props.history.push({
            pathname: "/app/claimresponse/" + invoice_id
        });
    }

    viewInvoice = (invoice_id) => {
        this.props.history.push({
            pathname: "/app/invoicedetails/" + invoice_id
        });
    }

    goBack = () => {
        history.goBack()
    }

    render() {
        const data = this.props.mediclaimDetailsData.mediclaimDetails;

        if (!this.state.isScreenLoaded) {
            return (
                <div className="dashboard-loader">
                    <img src={ttmLoader} alt="loader" className="loader-image" />
                </div>
            );
        }

        return (
            <div className={`${style.mediclaimDetailsWrapper}`}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Claim Details</h3>
                    </div>
                </div>
                {/* <div className="row">
                <div className="col-lg-12 intro-text">
                    <p>
                    This is the list of all the invoices generated on the system. The
                    view action will take you to the invoice preview page.
                    </p>
                </div>
                </div> */}
                <div className="row">
                    <div className="col-md-12">
                        <div className={style.mediclaimDetailsBoxWrapper}>
                            <h5 className="">Claim Information</h5>
                            <div className="row">
                                <div className="col-md-6">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Ref. Tracking No.</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.scheme_destination_claimreference_tracking_number)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Claim Date</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(dateFormatter(data.service_start_date))}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Status</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.status)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Responding Party</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.responding_party_name)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Delivery Type Indicator</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.mediswitch_delivery_type_indicator_name)}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Claimed Amount </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.claimed_amount)}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Liable Amount</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.scheme_liable_amount)}
                                        </div>
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Patient Liable Amount </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.patient_liable_amount)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Authorised Amount </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.scheme_authorized_amount)}
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Switch Ref. Number </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.swref_no)}
                                        </div>
                                    </div>
                                </div>

                                {data && data.failure_response_record && (
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Failure Response</label> :{" "}
                                            </div>

                                            <div className="col-md-6">
                                                {this.checkFailureResponseData(data.failure_response_record)}
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {data && data.response_record && (
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Response</label> :{" "}
                                            </div>

                                            <div className="col-md-6">
                                                {this.checkResposneData(data.response_record)}
                                            </div>
                                        </div>
                                    </div>)}



                                {data && data.general_comment && (
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>General comment</label> :{" "}
                                            </div>

                                            <div className="col-md-6">
                                                {this.checkGeneralCommentsData(data.general_comment)}
                                            </div>
                                        </div>
                                    </div>)}
                                {data && data.drug_utilization_record && (
                                    <div className="col-md-12 mt-2">
                                        <hr />
                                        <div className="row">
                                            <div className="collapsible-box col-md-12" onClick={this.openDrugRecord}>
                                                <h6>Drug Utilization Record</h6>
                                                {this.state.isDrugRecordOpen ? (
                                                    <i className="fa fa-angle-up" aria-hidden="true"></i>
                                                ) : (
                                                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                                                    )}
                                            </div>
                                            <Collapse isOpen={this.state.isDrugRecordOpen}>

                                                {this.checkDrugRecord(data.drug_utilization_record)}
                                            </Collapse>
                                        </div>
                                    </div>)}

                            </div>
                        </div>



                        <div className={style.mediclaimDetailsBoxWrapper}>
                            <h5 className="">Credits Information</h5>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Total Amount (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.total)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Claimed Amount (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.claimed_amount)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Liable Amt. (ZAR)</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.scheme_liable_amount)}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Auth. Amt. (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.scheme_authorized_amount)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Patient Liable Amt. (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.patient_liable_amount)}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Amount Paid (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.amount_paid)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Balance Payable Amt. (ZAR)</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && formatNumberToCurrency(data.balance)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {data && Math.sign(Number(data.balance)) === 1 && (
                                                <span className="balance-warn-message">
                                                     <i class="fa fa-warning fa-lg"></i>{" "}
                                                    There is possible outstanding amount that must be collected from the patient.</span>
                                            ) }
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>



                        <div className={style.mediclaimDetailsBoxWrapper}>
                            <h5 className="">Account Information</h5>
                            <div className="row">
                                <div className="col-md-6">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Patient Name</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.patient_name)}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Dependent Code</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.dependant_code)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Date of Birth</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(dateFormatter(data.dob))}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>ID Number</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.passport_number)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Gender </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.gender)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Email ID </label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.email)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Member Name</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.member_name)}
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Membership No.</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.membership_number)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Member Scheme</label> :{" "}
                                        </div>
                                        <div className="col-md-6">
                                            {data && this.checkData(data.scheme_name)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Scheme Plan</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.plan_name)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Phone Number</label> :{" "}
                                        </div>

                                        <div className="col-md-6">
                                            {data && this.checkData(data.contact_number)}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row ">
                            <div className="col-md-12">
                                {this.state.submitClaimLoader && (
                                    <div className={`error loadingWrapper`}>
                                        <img src={ttmLoader} alt="loader" className={style.loading} />
                                    </div>
                                )}
                                {!this.state.submitClaimLoader &&
                                    this.state.successMessage && (
                                        <div>
                                            <p className={style.successMessage}>{this.state.successMessage}</p>
                                        </div>)}
                                {!this.state.submitClaimLoader &&
                                    this.state.errorMessage && (<div>
                                        <p className={style.errorMessage}>{this.state.errorMessage}</p>
                                    </div>
                                    )}
                            </div>
                        </div>

                        <div className={`row ${style.mediclaimDetailsBtnWrapper}`}>
                            <div className={`col-md-12  d-flex
                                        justify-content-between
                                        flex-column-reverse
                                        flex-md-row
                                        align-items-center ${style.btnWrapper}`}>
                                <div>
                                    <Button type="button" onClick={this.goBack}
                                        className="form-primary-btn mt-2">
                                        Back
                                    </Button>
                                    {data && data.invoice_id && checkIfPermitted(Permissions.VIEW_INVOICE) && (<Button
                                        className="ttm-primary-btn ml-3 mt-2"
                                        type="button"
                                        onClick={() => this.viewInvoice(data.invoice_id)}
                                    >
                                        View Invoice
                                                </Button>)}
                                    {data && data.invoice_id &&(<Button
                                        className="ttm-primary-btn ml-3 mt-2"
                                        type="button"
                                        onClick={() => this.claimResponse(data.invoice_id)}
                                    >
                                        Claim Response History
                                                </Button>)}
                                    {(data && (data.mediswitch_delivery_type_indicator === "02" || data.mediswitch_delivery_type_indicator === "03" || data.response_result_code === "03" || data.response_result_code === "06" || data.response_result_code === "07")) && (
                                        <Button
                                            className="ttm-primary-btn ml-3 mt-2"
                                            type="button"
                                            onClick={this.toggle}
                                        >
                                            Resubmit Claim
                                        </Button>
                                    )}

                                    {(data && data.mediswitch_delivery_type_indicator === "01" &&
                                        data.switch_claim_reversal_allowed === "Y") && (<Button
                                            className="ttm-primary-btn ml-3 mt-2"
                                            type="button"
                                            onClick={this.reverseClaim}
                                        >
                                            Reverse Claim
                                        </Button>)}
                                    {Math.sign(Number(data.scheme_authorized_amount)) === 1 && (
                                        <Button
                                            className="ttm-primary-btn ml-3 mt-2"
                                            type="button"
                                            onClick={this.captureSchemePayment}
                                        >
                                            Capture Scheme Payment
                                        </Button>)}
                                    {Math.sign(Number(data.balance)) === 1 && (
                                        <Button
                                            className="ttm-primary-btn ml-3 mt-2"
                                            type="button"
                                            onClick={this.balancePay}
                                        >
                                            Outstanding Payment
                                        </Button>)}
                                    {Math.sign(Number(data.balance)) === -1 && (
                                        <Button
                                            className="ttm-primary-btn ml-3 mt-2"
                                            type="button"
                                            onClick={this.makePayment}
                                        >
                                            Make Payment
                                        </Button>)}
                                </div>
                            </div>
                        </div>

                        {/* <div className="row ">
        <div className="col-md-12">
          {isLoading ? (
            <div className={`error ${style.loadingWrapper}`}>
              <img src={ttmLoader} className={style.loading} />
            </div>
          ) : (
            <div>
              {successMsg && (
                <p className={style.successMessage}>{successMsg}</p>
              )}
              {errorMsg && <p className={style.errorMessage}>{errorMsg}</p>}
            </div>
          )}
        </div>
      </div> */}


                        <Modal
                            isOpen={this.state.isDeleteModalOpen}
                            toggle={this.toggle}
                            className={style.deleteReason}
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggle}
                                className={style.deleteReasonHeader}
                            >
                                Resubmit claim reason
            </ModalHeader>
                            <ModalBody>
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        reasonType: Yup.string().required("Reason is required")
                                    })}
                                    onSubmit={this.resubmitClaim}
                                >
                                    {({ errors, status, touched }) => (
                                        <Form>
                                            <div className={style.deleteReasonHeadingWrapper}>
                                                <p>
                                                    Please choose a reason for resubmitting the claim{" "}
                                                </p>
                                            </div>
                                            <div className={style.deleteReasonFormWrapper}>
                                                <div className="form-group">
                                                    <Field
                                                        as="select"
                                                        name="reasonType"
                                                        placeholder="Reason Type"
                                                        className={
                                                            "form-control" +
                                                            (errors.reasonType && touched.reasonType
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleReasonChange}
                                                        value={this.state.reasonType}

                                                    >
                                                        <option value="">Select Reason</option>
                                                        <option value="01">Unpaid Claims</option>
                                                        <option value="02">Details Changed</option>
                                                    </Field>
                                                    <ErrorMessage
                                                        name="reasonType"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />

                                                </div>
                                                <div className={`row ${style.deleteBtnWrapper}`}>
                                                    <div className="col-lg-12">
                                                        <div>
                                                            <button
                                                                type="submit"
                                                                disabled={this.state.successMessage}
                                                                className={`mr-4 ${style.deleteBtn}`}
                                                            >
                                                                Proceed
                        </button>
                                                            <button
                                                                type="button"
                                                                disabled={this.state.successMessage}
                                                                className={style.cancelBtn}
                                                                onClick={this.toggle}
                                                            >
                                                                Cancel
                        </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* {(this.state.successMessage || this.state.errorMessage) && (
                                                        <div className="row">
                                                            {this.state.successMessage && (<p className={style.successMessage}>
                                                                {this.state.successMessage}
                                                            </p>
                                                            )}
                                                            {this.state.errorMessage && (<p className={style.errorMessage}>
                                                                {this.state.errorMessage}
                                                            </p>)}
                                                        </div>
                                                    )} */}
                                            </div>
                                        </Form>
                                    )}

                                </Formik>
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (state) => {
    return {
        mediclaimDetailsData: state.mediclaimDetails,
        submitClaimData: state.claimSubmitResponse,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchMediclaimDetailsListing: (id) => dispatch(fetchMediclaimDetailsListing(id)),
        submitClaim: (payload) => dispatch(submitClaim(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediclaimDetails);
